import React, { useEffect } from "react";
import "./style.scss";

import { useSelector, useDispatch } from "react-redux";
import { setMenuDrawer } from "../../common/features/navigation/navigationActions";

import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import MenuDrawer from "../MenuDrawer/MenuDrawer";

interface IndexProps {
  setPaymentStatus?: (status: boolean) => void;
  setSwitchingOrderType?: (status: boolean) => void;
  setSignupPopup?: (status: boolean) => void;
  setCardDelete?: (status: boolean) => void;
  signupPopup?: boolean;
  Switch: boolean;
  currentOrdertypeDetails?: any;
  setCurrentOrdertypeDetails?: any;
  menuType?: string;
  basePath?: string;
  handleBack?: () => void;
  Logoutfn?: any;
  NavigateProfile?: any;
  GotoProfile?: any;
  isMobile?: boolean;
  isAccountPage?: boolean;
  selectedTab?: string;
  setSelectedTab?: (val: string) => void;
  setIsSearchActive?:any;
  setSearchedItem?:any;
  setSearchResults?:any;
  notShowBack?:any
  notShowuserIcon?:any

}

const MenuPageHeader: React.FC<IndexProps> = ({
  setPaymentStatus,
  setSignupPopup,
  setCardDelete,
  signupPopup,
  Switch,
  currentOrdertypeDetails,
  setCurrentOrdertypeDetails,
  menuType,
  Logoutfn,
  handleBack,
  NavigateProfile,
  GotoProfile,
  // isMobile,
  setIsSearchActive,
  isAccountPage,
  notShowBack,
  notShowuserIcon,

}) => {

  const dispatch = useDispatch();
  const showMenuDrawer = useSelector((state: any) => state.navigation.showMenuDrawer);
  const selectedTab = useSelector((state: any) => state.restaurant.selectedRestaurantTab);
  const setShowMenuDrawer = (show: boolean) => {
    dispatch(setMenuDrawer(show));
  };
  
  const isMobile = window.innerWidth <= 768;

  const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );

  const isDineInOrder = restaurantDetails?.orderTypes?.some(
    (type: any) =>  type?.typeGroup === 'D' && type?.typeName === menuType
  );  


  return <>
  {!isMobile ? (
  <DesktopHeader
    setPaymentStatus={setPaymentStatus}
    setSignupPopup={setSignupPopup}
    setCardDelete={setCardDelete}
    signupPopup={signupPopup}
    Switch={Switch}
    currentOrdertypeDetails={currentOrdertypeDetails}
    setCurrentOrdertypeDetails={setCurrentOrdertypeDetails}
    menuType={menuType}
    handleBack={handleBack}
    notShowBack={notShowBack}
    NavigateProfile={NavigateProfile}
    GotoProfile={GotoProfile}
    isAccountPage={isAccountPage}
    selectedTab={selectedTab}
    setShowMenuDrawer={setShowMenuDrawer}
  />
  ):(

 
  <MobileHeader
      setPaymentStatus={setPaymentStatus}
      setSignupPopup={setSignupPopup}
      setCardDelete={setCardDelete}
      signupPopup={signupPopup}
      Switch={Switch}
    setIsSearchActive={setIsSearchActive}
      currentOrdertypeDetails={currentOrdertypeDetails}
      setCurrentOrdertypeDetails={setCurrentOrdertypeDetails}
      menuType={menuType}
      handleBack={handleBack}
          notShowBack={notShowBack}
      Logoutfn={Logoutfn}
      NavigateProfile={NavigateProfile}
      GotoProfile={GotoProfile}
      isMobile={isMobile}
      isAccountPage={isAccountPage}
      selectedTab={selectedTab} 
      notShowuserIcon={notShowuserIcon}
      setShowMenuDrawer={setShowMenuDrawer}
      /> 
    )}  
  
  <MenuDrawer showMenuDrawer={Switch&&showMenuDrawer} setShowMenuDrawer={setShowMenuDrawer}/>
  </>
};

export default MenuPageHeader;
